import { render, staticRenderFns } from "./headbgm.vue?vue&type=template&id=01697be4&scoped=true&"
import script from "./headbgm.vue?vue&type=script&lang=js&"
export * from "./headbgm.vue?vue&type=script&lang=js&"
import style0 from "./headbgm.vue?vue&type=style&index=0&id=01697be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01697be4",
  null
  
)

export default component.exports